"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryToCurrency = exports.currencyToCountry = exports.defaultHousesSystem = exports.toLocaleISOString = exports.getLocalTime = exports.localTime = exports.getUTMCommentForCP = exports.searchParams = exports.degToInternationalString = exports.radialPoint = exports.fitToRange = exports.fitString = exports.daysBetweenDates = exports.distance = exports.degToString = exports.fromDateTime = exports.toDateTime = exports.isValidISOString = exports.fillNumber = exports.toISOString = exports.parseISOString = exports.nowISOString = exports.toDateTimeString = exports.deg2rad = exports.getDay = exports.capitalize = exports.commonSuffixes = exports.commonSuffixesTr = exports.getSuffix = void 0;
var dayjs_1 = __importDefault(require("./dayjs"));
var libs_1 = require("./libs");
var region_1 = require("./region");
function getSuffix(value, txt) {
    var cases = [2, 0, 1, 1, 1, 2];
    return txt[value % 100 > 4 && value % 100 < 20 ?
        2 :
        cases[value % 10 < 5 ? value % 10 : 5]];
}
exports.getSuffix = getSuffix;
exports.commonSuffixesTr = {
    minutes: ["chronos.app.commonSuffixes.minute.nom", "chronos.app.commonSuffixes.minute.gen", "chronos.app.commonSuffixes.minute.plural"],
    hours: ["chronos.app.commonSuffixes.hour.nom", "chronos.app.commonSuffixes.hour.gen", "chronos.app.commonSuffixes.hour.plural"],
    days: ["chronos.app.day.nom", "chronos.app.day.gen", "chronos.app.day.plural"],
    months: ["chronos.app.month.lower", "chronos.app.month.lower.gen", "chronos.app.month.lower.gen.plural"],
    years: ["chronos.app.year.acc", "chronos.app.year.gen", "chronos.app.year.plural"],
    sessions: ["chronos.app.commonSuffixes.session.nom", "chronos.app.commonSuffixes.session.gen", "chronos.app.commonSuffixes.session.plural"],
    forms: ["chronos.app.dashboard.map.nom", "chronos.app.dashboard.map.gen", "chronos.app.dashboard.map.plural"],
};
exports.commonSuffixes = {
    minutes: ['минуту', 'минуты', 'минут'],
    hours: ['час', 'часа', 'часов'],
    days: ['день', 'дня', 'дней'],
    months: ['месяц', 'месяца', 'месяцев'],
    years: ['год', 'года', 'лет'],
    sessions: ['сеанс', 'сеанса', 'сеансов'],
    forms: ['карта', 'карты', 'карт'],
};
function capitalize(s) {
    if (!s.length) {
        return s;
    }
    return s[0].toUpperCase() + s.substr(1);
}
exports.capitalize = capitalize;
function getDay(dt) {
    var v = dt.day();
    var day = v ? v - (dt.locale() === 'en' ? 0 : 1) : 6;
    return day;
}
exports.getDay = getDay;
function deg2rad(deg) {
    return -deg * Math.PI / 180;
}
exports.deg2rad = deg2rad;
function toDateTimeString(dt) {
    var _a = toDateTime(dt), date = _a.date, time = _a.time;
    return "".concat(date, ", ").concat(time);
}
exports.toDateTimeString = toDateTimeString;
function nowISOString() {
    return new Date().toISOString();
}
exports.nowISOString = nowISOString;
function parseISOString(value) {
    var _a, _b;
    return (_b = (_a = value.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})Z/)) === null || _a === void 0 ? void 0 : _a.slice(1).map(function (t) { return +t; })) !== null && _b !== void 0 ? _b : [];
}
exports.parseISOString = parseISOString;
function toISOString(year, month, date, hours, minutes, seconds, millis) {
    return "".concat(fillNumber(year, 4), "-").concat(fillNumber(month, 2), "-").concat(fillNumber(date, 2), "T").concat(fillNumber(hours, 2), ":").concat(fillNumber(minutes, 2), ":").concat(fillNumber(seconds, 2), ".").concat(fillNumber(millis, 3), "Z");
}
exports.toISOString = toISOString;
function fillNumber(v, digits) {
    if (digits === void 0) { digits = 2; }
    return v < Math.pow(10, digits) ?
        "".concat('0'.repeat(digits - v.toString().length)).concat(v) :
        v.toString();
}
exports.fillNumber = fillNumber;
function isValidISOString(date) {
    return !isNaN(new Date(date).valueOf());
}
exports.isValidISOString = isValidISOString;
function toDateTime(dt) {
    var isBC = dt === null || dt === void 0 ? void 0 : dt.startsWith('-');
    try {
        var _a = __read(dt.match(/(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})\.\d+(Z|[-+]\d{2}:\d{2})/), 3), date = _a[1], time = _a[2];
        return {
            date: "".concat(date.split('-').reverse().join('.')).concat(isBC ? 'B' : ''),
            time: time
        };
    }
    catch (_b) {
        return {
            date: '01.01.2021',
            time: '00:00:00'
        };
    }
}
exports.toDateTime = toDateTime;
function fromDateTime(date, time, isBC) {
    if (isBC === void 0) { isBC = false; }
    var _a = __read(date.split('.'), 3), day = _a[0], month = _a[1], year = _a[2];
    return "".concat(isBC ? "-".concat(year.padStart(6, '0')) : year, "-").concat(month, "-").concat(day, "T").concat(time, ".000Z");
}
exports.fromDateTime = fromDateTime;
function degToString(value, opts) {
    var _opts = __assign({ showSeconds: false, isLatitude: false, isInternational: true }, opts);
    var neg = value < 0;
    value = Math.abs(value);
    var degrees = Math.floor(value);
    value -= degrees;
    var minutes = Math.floor(value * 60);
    value -= minutes / 60;
    var symbol = _opts.isInternational ?
        (_opts.isLatitude ?
            (neg ? 'S' : 'N') :
            (neg ? 'W' : 'E')) :
        "";
    var sign = _opts.isInternational ?
        "" :
        (neg ? "-" : "");
    var seconds = _opts.showSeconds ? "".concat(fillNumber(Math.floor(value * 3600)), "\"") : "";
    return "".concat(sign).concat(degrees, "\u00B0").concat(fillNumber(minutes), "'").concat(seconds).concat(symbol);
}
exports.degToString = degToString;
function distance(p1, p2) {
    var dx = p1.x - p2.x;
    var dy = p1.y - p2.y;
    return Math.sqrt(dx * dx + dy * dy);
}
exports.distance = distance;
function daysBetweenDates(start, end) {
    var a = Date.parse(start);
    var b = Date.parse(end);
    return Math.floor(Math.abs(b - a) / (1000 * 60 * 60 * 24));
}
exports.daysBetweenDates = daysBetweenDates;
function fitString(s, max) {
    return s.length > max ? "".concat(s.substr(0, max - 3), "...") : s;
}
exports.fitString = fitString;
function fitToRange(value, min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 1; }
    return Math.max(min, Math.min(max, value));
}
exports.fitToRange = fitToRange;
function radialPoint(x, y, r, a) {
    var angle = deg2rad(a);
    return {
        x: x + r * Math.cos(angle),
        y: y + r * Math.sin(angle)
    };
}
exports.radialPoint = radialPoint;
function degToInternationalString(value, isLatitude, showSeconds) {
    if (isLatitude === void 0) { isLatitude = true; }
    if (showSeconds === void 0) { showSeconds = false; }
    var neg = value < 0;
    value = Math.abs(value);
    var degrees = Math.floor(value);
    value -= degrees;
    var minutes = Math.floor(value * 60);
    value -= minutes / 60;
    var seconds = Math.floor(value * 3600);
    var symbol = isLatitude ?
        neg ? 'S' : 'N' :
        neg ? 'W' : 'E';
    return "".concat(degrees, "\u00B0").concat(fillNumber(minutes), "'").concat(showSeconds ? "".concat(fillNumber(seconds), "\"") : "").concat(symbol);
}
exports.degToInternationalString = degToInternationalString;
function searchParams() {
    return new URLSearchParams(window.location.search);
}
exports.searchParams = searchParams;
function getUTMCommentForCP() {
    var e_1, _a;
    var sp = searchParams();
    var url = window.location.href;
    var isFind = false;
    var regex = /utm/;
    try {
        for (var _b = __values(sp.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (regex.test(key)) {
                isFind = true;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return isFind ? url : undefined;
}
exports.getUTMCommentForCP = getUTMCommentForCP;
function localTime(data) {
    return getLocalTime(data.dt, data.gmt, data.place.lat, data.place.lon);
}
exports.localTime = localTime;
function getLocalTime(dt, gmt, lat, lon) {
    if (lat === void 0) { lat = 0; }
    if (lon === void 0) { lon = 0; }
    return dayjs_1.default.utc(dt)
        .add(-(gmt === null ? (0, libs_1.getGMT)(dt, lat, lon) : gmt), 'hours')
        .toISOString();
}
exports.getLocalTime = getLocalTime;
function toLocaleISOString(dt) {
    return (0, dayjs_1.default)(dt).add((0, dayjs_1.default)(dt).utcOffset(), 'minute').toISOString();
}
exports.toLocaleISOString = toLocaleISOString;
exports.defaultHousesSystem = {
    common: libs_1.HousesSystem.Placidus,
    northern: libs_1.HousesSystem.Equal,
    horar: libs_1.HousesSystem.Placidus,
};
var currencyToCountry = function (currency) {
    switch (currency) {
        case region_1.CurrencyCode.RUB: return 'ru';
        case region_1.CurrencyCode.KZT: return 'kz';
        default: return 'us';
    }
};
exports.currencyToCountry = currencyToCountry;
var countryToCurrency = function (country) {
    switch (country) {
        case 'kz': return region_1.CurrencyCode.KZT;
        case 'ru': return region_1.CurrencyCode.RUB;
        default: return region_1.CurrencyCode.USD;
    }
};
exports.countryToCurrency = countryToCurrency;
